import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { withAppHOC } from '../../../hoc';
import PageHeading from '../../../components/PageHeader/PageHeader';
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader';
import { Grid, GridItem } from '../../../components/Grid';
import {
  FormContainer,
  Form,
  Fieldset,
  Label,
  TextInput,
  NumberInput,
  MessageBox,
  UpdateButton,
  ResetButton,
  Dropdown,
} from '../../../components/FormElements';
import API from '../../../api';
import { API_RESPONSE_TYPES } from '../../../constants';

const PackagesUpdate = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [packageName, setPackageName] = useState('');
  const [packageType, setpackageType] = useState('');
  const [description, setDescription] = useState('');
  const [chargePerHit, setChargePerHit] = useState('');
  const [price, setPrice] = useState('');
  const [duration, setDuration] = useState('');
  const [originalFormData, setOriginalFormData] = useState({});
  const { id } = useParams();

  const packageTypeOptions = [
    { title: '-- SELECT PACKAGE TYPE --', value: '' },
    { title: 'Fixed', value: 'Fixed' },
    { title: 'Pay As you Go', value: 'Pay As you Go' },
  ];

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus('');
    setResponseMessage('');
  };

  const resetForm = () => {
    const { packageName, duration } = originalFormData;
    setPackageName(packageName);
    setDuration(duration);
    setChargePerHit(chargePerHit);
    setpackageType(packageType);
    setDescription(description);
    setPrice(price);
  };

  const readData = useCallback(() => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get(`/packages/${id}`)
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILURE) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          const { packageName, duration, chargePerHit, packageType, description, price } = data[0];
          setPackageName(packageName);
          setDuration(duration);
          setChargePerHit(chargePerHit);
          setpackageType(packageType);
          setDescription(description);
          setPrice(price);
          setOriginalFormData({
            packageName,
            duration,
            chargePerHit,
            packageType,
            description,
            price,
          });
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.put(`/packages/${id}`, {
      packageName,
      duration,
      chargePerHit,
      packageType,
      description,
      price
    })
      .then((response) => {
        const { status, message } = response.data;
        setResponseStatus(status);
        setResponseMessage(message);
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setOriginalFormData({
            packageName,
            duration,
            chargePerHit, 
            packageType,
            description,
            price
          });
          setTimeout(() => {
            resetResponseData();
            window.location.href = '/accounting/packages';
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    readData();
  }, [readData]);

  return (
    <>
      <PageHeading {...props} />
      <FormContainer>
        <Form method='POST' action='#' onSubmit={onSubmit}>
          <GridItem>
            <Fieldset>
              <Label required>Package Name</Label>
              <TextInput
                placeholder='Please enter package name'
                value={packageName}
                onChange={setPackageName}
                maxLength={200}
                autoComplete='off'
                disabled={isLoading}
              />
            </Fieldset>
          </GridItem>
          <GridItem>
            <Fieldset>
              <Label required>Description</Label>
              <TextInput
                placeholder='Please Description'
                value={description}
                onChange={setDescription}
                autoComplete='off'
                disabled={isLoading}
              />
            </Fieldset>
          </GridItem>
          <GridItem>
            <Fieldset>
              <Label required>Amount</Label>
              <NumberInput
                placeholder='Please Enter Package Price'
                value={price}
                onChange={setPrice}
                autoComplete='off'
                disabled={isLoading}
              />
            </Fieldset>
          </GridItem>
          <GridItem>
            <Fieldset>
              <Label required>Package Type</Label>
              <Dropdown
                placeholder='Please select Package Type'
                value={packageType}
                onChange={setpackageType}
                options={packageTypeOptions}
                disabled={isLoading}
              />
            </Fieldset>
          </GridItem>
          {packageType === 'Fixed' && (
            <GridItem>
              <Fieldset>
                <Label required>Duration</Label>
                <NumberInput
                  placeholder='Please enter plan duration in days'
                  value={duration}
                  onChange={setDuration}
                  autoComplete='off'
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
          )}
          {packageType === 'Pay As you Go' && (
            <GridItem>
              <Fieldset>
                <Label required>Charge Per Hit</Label>
                <NumberInput
                  placeholder='Please enter Charge Per Hit'
                  value={chargePerHit}
                  onChange={setChargePerHit}
                  autoComplete='off'
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
          )}
          {responseStatus && (
            <Fieldset>
              <MessageBox status={responseStatus} message={responseMessage} />
            </Fieldset>
          )}
          <Fieldset>
            <UpdateButton disabled={isLoading} type='submit'>
              Update
            </UpdateButton>
            <ResetButton disabled={isLoading} type='button' onClick={resetForm}>
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
        <OverlayLoader showLoader={isLoading} />
      </FormContainer>
    </>
  );
};

export default withAppHOC(PackagesUpdate);
